import clsx from 'clsx';
import { useFitText } from '@flyyer/use-fit-text';
import '../../../../font.css';
import { addPontis } from '../../../../store/utils';
import { FitPriceProps } from '.';
import { useEffect, useRef, useState } from 'react';

export default function FitPriceSecondary({
  width = 0,
  height = 0,
  matrix = [0, 0, 0, 0, 0, 0],
  text = '',
  top = 0,
  left = 0,
  right,
  color = [0, 0, 0],
  textAlign,
  display = 'flex',
  margin = 'auto',
  fontFamily = '"Primary"',
  fontWeight = 'normal',
  variant,
  params,
  alignItems,
}: FitPriceProps) {
  const [refresh, setRefresh] = useState(false);
  const isRight = right !== undefined ? true : false;
  // UI-dependent variables (title and description) are added to the hook's dependency array.
  const { ref, fontSize, isCalculating } = useFitText(
    {
      /** Depends on body's fontSize (usually 16px) */
      maxFontSize: 2000, // 1000%
      /** Lower values are more strict but causes more renders, defaults to `5` */
      resolution: 10,
    },
    [width, height, text, refresh],
  );

  const real = addPontis(Math.floor(+text / 100).toString());
  const cent = (+text % 100).toString().padStart(2, '0');

  const className = clsx({ 'flyyer-wait': isCalculating });
  const currencyRef = useRef<HTMLInputElement | null>(null);
  const [offset, setOffset] = useState({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
  });
  useEffect(() => {
    if (currencyRef.current) {
      const {
        offsetWidth: width,
        offsetHeight: height,
        offsetTop,
        offsetLeft,
      } = currencyRef.current;
      setOffset({
        width: width + 0.6 * height,
        height,
        top: top + offsetTop,
        left: left + offsetLeft - 0.3 * height,
      });
    }
  }, [isCalculating, refresh]);

  useEffect(() => {
    const timer = setInterval(() => {
      clearInterval(timer);
      setRefresh(!refresh);
    }, 1000);
  }, []);

  return (
    <div
      style={{
        transition: 'transform 500ms, color 500ms',
        transformOrigin: `${isRight ? 'right' : 'left'} top`,
        transform: `matrix(${matrix.join(', ')})`,
        color: `rgb(${color[0]},${color[1]},${color[2]})`,
      }}
    >
      <div
        ref={ref}
        style={{
          position: 'absolute',
          display,
          transition:
            'height 500ms, width 500ms, top 500ms, left 500ms, right 500ms',
          top,
          ...(() => (isRight ? { right } : { left }))(),
          fontSize,
          fontFamily,
          fontWeight,
          letterSpacing: '2px',
          height,
          width,
          whiteSpace: 'pre',
          textAlign,
          alignItems,
        }}
        className={className}
      >
        <div
          ref={currencyRef}
          style={{
            margin,
          }}
        >
          <span
            style={{
              fontSize,
            }}
          >
            {real}
          </span>
          <span
            style={{
              position: 'relative',
              display: 'inline-flex',
              fontSize: `calc(${fontSize} / 1.5)`,
              transform: 'translateY(-30%)',
              marginLeft: '5px',
            }}
          >
            {`${cent}`}
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(20%)',
              }}
            >
              ,
            </span>
            {params
              ? (() => {
                  switch (params[0]) {
                    case 'M2':
                      return (
                        <span
                          style={{
                            position: 'absolute',
                            fontSize: `15%`,
                            bottom: '0',
                            right: '10%',
                            color: `rgb(${color[0]},${color[1]},${color[2]})`,
                            width: '68%',
                          }}
                        >
                          {params[0][0].toLowerCase()}
                          <span
                            style={{
                              position: 'absolute',
                              fontSize: `70%`,
                            }}
                          >
                            {params[0][1]}
                          </span>
                        </span>
                      );
                    default:
                      return (
                        <span
                          style={{
                            position: 'absolute',
                            fontSize: `15%`,
                            bottom: '-3%',
                            right: '10%',
                            color: `rgb(${color[0]},${color[1]},${color[2]})`,
                            width: '68%',
                          }}
                        >
                          {params[0]}
                        </span>
                      );
                      break;
                  }
                })()
              : null}
          </span>
        </div>
      </div>
      {variant === 'secondaryOld' ? (
        <div
          style={{
            position: 'absolute',
            height: offset.height,
            width: offset.width,
            top: offset.top,
            left: offset.left,
            backgroundImage: `url(/xOldPrice.png)`,
            backgroundSize: '100% 100%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
      ) : null}
    </div>
  );
}
